import { ReactNode } from 'react'
import { cn } from '@/utilities/ui'

export interface InfoTagProps {
  children: ReactNode
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div' | 'span'
  className?: string
  color?: 'brand' | 'white' | 'dark'
  size?: 'sm' | 'md' | 'lg'
}

export default function InfoTag({
  children,
  as: Component = 'div',
  className = '',
  color = 'brand',
  size = 'md',
}: InfoTagProps) {
  const colorClasses = {
    brand: 'bg-brand text-text-white',
    white: 'bg-white text-text-primary',
    dark: 'bg-dark text-text-white',
  }

  const sizeClasses = {
    sm: 'px-3 py-2 text-sm',
    md: 'px-3 py-1 text-base',
    lg: 'px-3 py-1 text-lg',
  }

  const baseClasses = 'inline-flex items-center gap-3 font-metropolis w-fit uppercase'

  return (
    <Component className={cn(baseClasses, colorClasses[color], sizeClasses[size], className)}>
      <div className="w-1 h-1 bg-current"></div>
      <span>{children}</span>
    </Component>
  )
}
